<button routerLink="/messages" class="icon-button">
  <img src="/images/icons/message.svg" alt="Messages" width="16" height="16" style="filter: brightness(0)" />
  <span>{{ "topNav.actions.messages" | translate }}</span>
  @if (chatService.unseenMessages()) {
    <span class="new-messages-badge">
      @if (chatService.unseenMessages() < 99) {
        {{ chatService.unseenMessages() }}
      } @else {
        +99
      }
    </span>
  }
</button>
